export default __webpack_public_path__ + "static/content-valuation-ad-7882602890d5d146ccabaf911d667c0d.jpg";